module.exports = __webpack_public_path__ + "img/logo.1826e6a7.jpeg";